import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

const NotFound = () => (
  <div className="flex min-h-[70vh] flex-col items-start justify-center px-4 pt-24 sm:px-6" data-testid="not-found-page">
    <Seo title="Page Not Found | Xtreme Protection Wales" description="The page you requested could not be found. Explore security services and locations across Wales." path="/404" noindex />
    <p className="eyebrow">404 // Signal Lost</p>
    <h1 className="font-condensed mt-4 text-6xl font-bold uppercase leading-none text-white sm:text-7xl">Page not found</h1>
    <p className="mt-4 max-w-md text-base text-[#9BA1AB]">This perimeter is unguarded — the page you requested doesn't exist. Head back to secured territory.</p>
    <div className="mt-8 flex flex-wrap gap-3">
      <Link to="/" data-testid="notfound-home-btn" className="bg-[#F5A800] px-6 py-3.5 text-sm font-bold uppercase tracking-[0.14em] text-[#0A0C10] transition-colors duration-300 hover:bg-white">
        Back to Home
      </Link>
      <Link to="/locations" data-testid="notfound-locations-btn" className="border border-white/25 px-6 py-3.5 text-sm font-bold uppercase tracking-[0.14em] text-white transition-colors duration-300 hover:border-[#F5A800] hover:text-[#F5A800]">
        Wales Locations
      </Link>
    </div>
  </div>
);

export default NotFound;
